import React from "react";
import "@/styles/components/cardWrapper.scss";

const CardWrapper = ({
  children,
  className = "",
  isPadded = false,
  isBordered = false,
  ...rest
}) => {
  return (
    <div className={`custom-card ${isPadded ? "custom-card-padding" : ""} ${className}`} {...rest}>
      {isBordered ? (
        <div className={` ${isBordered ? "custom-card-border" : ""} `}>{children}</div>
      ) : (
        children
      )}
    </div>
  );
};

export default CardWrapper;
